import { useMutation, useQueryClient } from "@tanstack/react-query";
import { myDashboardApi } from "@/features/my-dashboard/api";
import { MyDashboardLinkUrlSiteParams } from "@/features/my-dashboard/types";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

const usePostMyDashboardLinkUrlSite = (buyer_id?: number) => {
  const queryClient = useQueryClient();
  const { info } = useAppToasts();
  const { mutate: linkUrlSite } = useMutation({
    mutationFn: (params: MyDashboardLinkUrlSiteParams) =>
      myDashboardApi.postLinkUrlSite(params, buyer_id),
    mutationKey: ["my-dashboard", "link-url", buyer_id],
    onSuccess: () => {
      info("요청 사항이 제출되었습니다.");
      queryClient.invalidateQueries({
        queryKey: ["my-dashboard", "link-url", buyer_id],
      });
    },
  });
  return {
    linkUrlSite,
  };
};

export default usePostMyDashboardLinkUrlSite;
